<template>
    <div class="new_content"> 
        <div class="flex_spw cont_heard " >
            <Button @click="seeJHM()" style="background:#FF761D;color:#fff;border-color:#FF761D">下单</Button>
            <div class="flex_sta" >
                <div style="margin-right:16px">                    
                    <Input v-model="pageForm.account" placeholder="请输入账户或手机号" @on-enter="goSearch()" style="width: auto">
                    </Input>                    
                </div>
                <div style="margin-right:16px">
                    <Select filterable  transfer  v-model="pageForm.type" style="width:200px" placeholder="请选择套餐类型" clearable >
                        <Option v-for="item in pluginTypeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>                   
                </div>
                <div style="margin-right:16px">
                    <Select filterable  transfer  v-model="pageForm.application_id" style="width:200px" placeholder="请选择产品搜索" clearable >
                        <Option v-for="item in applicationList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>                    
                </div>
                <Button @click="goSearch()" style="background:#FF761D;color:#fff;border-color:#FF761D">搜索</Button>
                
            </div>
        </div>
        <div class="cont_tab">
            <!-- @on-selection-change="chooseData" -->
            <Table :columns="columns12" :data="data6" :loading="loadingone"  >
                <template slot-scope="{ index }" slot="index">
                    <strong>{{ index+1 }}</strong>
                </template>
                <template slot-scope="{ row }" slot="user_info">
                    {{ row.user_info.account }}
                </template>
                <template slot-scope="{ row }" slot="phone">
                    {{ row.user_info.phone }}
                </template>
                <template slot-scope="{ row }" slot="taocantype">
                    {{ row.type ==1 ?'插件套餐':'产品套餐' }}
                </template>
                <template slot-scope="{ row }" slot="plugin">
                    <div style="padding:8px 0">
                        <div v-for="item,index in row.plugin_object.map(item => item.name)" :key="index">
                            {{ item }}
                        </div>
                    </div>
                    <!-- {{ row.plugin.map(item => item.name).join() }}-->
                </template>    
                <template slot-scope="{ row }" slot="is_pay">
                    <div :style="row.is_pay==0?'color:red':''">
                        {{ row.is_pay == 0 ? "未付款" : '已付款'}}   
                    </div>            
                </template>                               
                <template slot-scope="{ row }" slot="action">
                    <!-- <Button v-if="row.is_pay==1" @click="seexqModal(row)" style="color:#3C90EE;background: unset;" type="text">退款</Button> -->
                    <Button v-if="row.is_pay==0" @click="golistpay(row)" style="color:#3C90EE;background: unset;" type="text">付款</Button>
                    <Button @click="del_use(row)" style="color:red;background: unset;" type="text">删除</Button>
                </template>
            </Table>
            <br />
            <Page :total="total" :current="pageForm.page" @on-change="pageChange" show-total show-elevator style="text-align:right" />
        </div>
        

        <!-- 查看弹框 -->
        <Modal v-model="showRefundModal" :mask-closable="false" width="600">
            <p slot="header" style="text-align:center">退款</p>
            <div class="flex_cen" style="padding-bottom:60px">
                <div class="form_box">
                    <div class="form_item_box"  style="margin-top:24px">
                        <div class="form_label da_font">产品名称：速速云签</div>                       
                    </div> 
                    <div class="form_item_box" >
                        <div class="form_label da_font">套餐名称：套餐一</div>                       
                    </div>   
                    <div class="form_item_box">
                        <div class="form_label">截至时间</div>
                        <div class="form_conter">
                            <DatePicker type="date" placeholder="请选择截至时间" style="width: 300px"></DatePicker>
                        </div>
                    </div> 
                    <div class="form_item_box">
                        <div class="form_label">剩余数量</div>
                        <div class="form_conter">
                            <Input v-model="JHM" style="width:300px" placeholder="请输入退款剩余数量"></Input>
                        </div>
                    </div>
                    <div class="form_item_box">
                        <div class="form_label">退款金额</div>
                        <div class="form_conter">
                            <Input v-model="JHM" style="width:300px" placeholder="请输入退款金额"></Input>
                        </div>
                    </div>
                    <div class="form_item_box" >
                        <div class="form_label red_text xiao_font">续费退款与产品退款，可以修改截止日期，截止日期默认为当前日期前一天</div>    
                        <div class="form_label red_text xiao_font">插件退款，可以修改套餐剩余数量和套餐截止日期，截止日期默认为当前日期前一天</div>                   
                    </div>
                </div>
            </div>
            <div slot="footer">
                <Button @click="showRefundModal = !showRefundModal">取消</Button>
                <Button @click="showRefundModal = !showRefundModal" style="background:#FF761D;color:#fff;border-color:#FF761D">确认</Button> 
            </div>
        </Modal>       

        <Modal v-model="showAddModal" width="600" :mask-closable="false">
            <p slot="header" style="text-align:center">
                <span>{{ addModalTitle == 'add' ? '下单' : '修改' }}</span>
            </p>
            <div class="">
                <div class="form_box">
                    <!-- addOrderData -->
                    <div class="form_item_box" >
                        <div class="form_label">账户:</div>
                        <div class="form_conter" >
                            <Select filterable  transfer  v-model="addOrderData.uid" style="width:300px" placeholder="请选择账户" clearable >
                                <Option v-for="item in userList" :value="item.uid" :key="item.uid">{{ item.newName }}</Option>
                            </Select>
                        </div>
                    </div>    
                    <div class="form_item_box" >
                        <div class="form_label" >产品:</div>
                        <div class="form_conter">
                            <Select filterable  transfer  v-model="addOrderData.goods_id" style="width:300px" placeholder="请选择产品" clearable @on-change="goGetgoodsList">
                                <Option v-for="item in applicationList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                                
                            </Select>
                        </div>
                    </div>    
                    <div class="form_item_box" >
                        <div class="form_label">套餐类型:</div>
                        <div class="form_conter">
                            <Select filterable  transfer  v-model="addOrderData.type" style="width:300px" placeholder="请选择套餐类型" clearable @on-change="goGetgoodsList">
                                <!-- <Option v-for="item in pluginTypeList" :value="item.id" :key="item.id">{{ item.name }}</Option> -->
                                <Option value="0" :disabled="addOrderData.goods_id===0">产品套餐</Option>
                                <Option value="1">插件套餐</Option>
                            </Select>
                        </div>
                    </div>     
                    <div class="form_item_box" >
                        <div class="form_label">套餐:</div>
                        <div class="form_conter">
                            <Select filterable  transfer  v-model="addOrderData.package_id" style="width:300px" @on-change="goOldPrice"
                                :placeholder="((this.addOrderData.type === 0 || this.addOrderData.type === 1) && this.addOrderData.goods_id) ? '请选择套餐' : '请先选择产品与套餐类型'" clearable>
                                <Option v-for="item in goodsList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                            </Select>
                        </div>
                    </div> 
                    <div class="form_item_box" v-if="oldPrice">
                        <div class="form_label">价格:</div>
                        <div class="form_conter">
                            {{ oldPrice }}
                        </div>                        
                    </div>  
                    <div class="form_item_box">
                        <div class="form_label">实付:</div>
                        <div class="form_conter">
                            <Input v-model="addOrderData.pay_money" style="width:300px" placeholder="请输入实付金额"></Input>
                        </div>                        
                    </div>
                </div>
            </div>
            <div slot="footer">
                <Button @click="showAddModal = !showAddModal" >取消</Button>
                <Button @click="goSubmit()" style="background:#FF761D;color:#fff;border-color:#FF761D">确认</Button>                
            </div>
        </Modal>        
        
        <Modal v-model="fkmodal" :mask-closable="false" width="710" @on-cancel="closeModal">
            <div slot="header" style="text-align:center" class="flex_cen">
                付款                
            </div>            
            <div class="modal_contene ">
                <div class="flex_sta san_class"  >
                    <!-- <div style="color:#FF761D;margin-right: 24px;cursor: pointer;" @click="downPayment()">线下付款</div> -->
                    <div :class="pay_type=='0'?'choose_box':'nochoose_box'"  @click="downPayment()">线下付款</div>
                    <div :class="pay_type=='1'?'choose_box':'nochoose_box'"  v-if="nextData.pay_money*1 " @click="goChooseType('1')">微信</div>
                    <div :class="pay_type=='2'?'choose_box':'nochoose_box'"  v-if="nextData.pay_money*1" @click="goChooseType('2')">支付宝</div>
                    <div :class="pay_type=='3'?'choose_box':'nochoose_box'" style="border-right: 0.5px solid rgb(180, 180, 180); " @click="goChooseType('3')">激活码</div>
                </div>
                <div class="flex_btw" >
                    <Form  label-position="left" :label-width="100">                    
                        <FormItem label="套餐名称">
                            <div>{{nextData.package_name}}</div>
                        </FormItem>                       
                        <FormItem label="订单号" >
                            <div>{{ nextData.order_no }}</div>
                        </FormItem>
                        <FormItem label="产品">
                            <div>{{nextData.name}}</div>
                        </FormItem>
                        <FormItem label="套餐价格">
                            <div class="flex_sta">
                                <div>{{nextData.pay_money}}</div>
                                <div style="color:#FF761D;margin-left: 24px;cursor: pointer;" @click="goEditMoney()">修改价格</div>
                            </div>
                        </FormItem>
                    </Form>  
                    <div class="fk_class" >                        
                        <div v-if="pay_type!='3'">                            
                            <img v-if="payFormData.qrcode_url !=''" :src="payFormData.qrcode_url" />
                        </div>
                        <div v-else class="flex_sta">
                            <Input v-model="authorize_code" placeholder="请输入激活码"></Input>
                            <Button  style="margin-left:8px;background:#FF761D;color:#fff;border-color:#FF761D" @click="getAddOrder('3')">激活</Button>
                        </div>
                    </div>
                </div>                   
            </div>
            <div slot="footer">
                <Button @click="closeModal" style="color:#fff" class="btn">确定</Button>
            </div>
        </Modal>
        <Modal v-model="editMoneyModal" width="510" :mask-closable="false">
            <p slot="header" style="text-align:center">
                <span>修改价格</span>
            </p>
            <div class="flex_cen">
                <div class="form_box">
                    <div class="form_item_box" >
                        <div class="form_label">价格</div>
                        <div class="form_conter" >
                            <Input v-model="newMoney" style="width:300px" placeholder="请输入订单价格"></Input>
                        </div>                        
                    </div>
                </div>
            </div>
            <div slot="footer">
                <Button @click="editMoneyModal = false" >取消</Button>
                <Button @click="submitMoney()" style="background:#FF761D;color:#fff;border-color:#FF761D">确认</Button>                
            </div>
        </Modal>    
    </div>
</template>

<script>
    import config from '@/config';
    import {getCookies} from '@/utils/helper'
    import { orders_list,edit_status,application_list,del_orders,pay_orders,get_list,goods_list,get_orderstatus } from "@/api/index";
import G from 'glob';
    export default {
        data(){
            return{
                header:{
                    'authori-admin-zation':getCookies('employeetoken')
                },
                model1:'',
                JHM:'',                
                baseURLs: config.apiUrl + '/adminapi/user/edit_album',
                avatarView:'',
                showOrderModal:false,
                showRefundModal:false,
                authorize_code:'',
                oldPrice: '',
                total:0,
                fkType:'weixin',
                pageForm:{
                    page: 1,
                    limit: 10,
                    account: '', 
                    type: '',
                    application_id: ''
                },
                addOrderData: {
                    goods_id: '',//	产品id 创建订单使用
                    pay_type: 1,//支付类型:1微信支付 2支付宝 3.激活码
                    order_id: '',//修改订单支付使用
                    pay_money: '',//支付金额
                    type: '',//	0产品套餐 1插件套餐
                    package_id: '', //套餐id
                    uid: '',//	商家id
                },
                goodsList: [],
                submitData: { // 这里是需要携带的数据
                    uid:null
                },                
                addModalTitle : 'add',
                contentTexe:'',               
                uid:null,
                formData:{},
                fkmodal:false,
                applicationList: [],
                seemodal: false,
                showAddModal: false,
                columns12: [
                    // {type: 'selection',width: 60,align: 'center'},
                    {title: '#',slot: 'index',align: 'center',},
                    {title: '订单号',key: 'order_no',align: 'center',},
                    {title: '账号',slot: 'user_info',align: 'center',},                    
                    {title: '手机号',slot: 'phone',align: 'center',},
                    {title: '产品',key: 'name',align: 'center',},
                    {title: '套餐类型',slot: 'taocantype',align: 'center',},
                    {title: '套餐名称',key: 'package_name',align: 'center',},
                    {title: '套餐',slot: 'plugin',align: 'center',width:'280'},    
                    {title: '订单金额',key: 'pay_money',align: 'center',},              
                    {title: '订单时间',key: 'created_at',align: 'center',},
                    {title: '付款状态',slot: 'is_pay',align: 'center',},
                    {title: '支付时间',key: 'pay_time',align: 'center',},
                    // {title: '禁用',slot: 'gender',align: 'center',},                    
                    {title: '操作',slot: 'action',width: 220,fixed: 'right',align: 'center',}
                ],
                data6: [],     
                loadingone:false,  
                pluginTypeList:[
                    { id: 0, name:'产品套餐'},
                    { id: 1, name:'插件套餐'},
                ],
                nextData:{}, //
                userList: [],
                payFormData: {},
                olddata: {},
                pay_type: '1',
                timer:'',
                editMoneyModal: false,
                newMoney:''
            }
        },
        created(){
            this.getList()
            this.application_list()
            this.getUserList()
        },
        computed: {           
        },
        methods:{
            getUserList(){
                let data = {
                    page: 1,
                    limit: 99999,
                }
                get_list(data).then(res=>{
                    this.userList= res.data.data
                    this.userList.forEach(item=>{
                        item.newName = item.account+':'+item.phone
                    })
                })
            },
            goOldPrice(e){
                if(e){
                    this.goodsList.forEach(item=>{
                        if(item.id==this.addOrderData.package_id){
                            this.oldPrice = item.price
                        }
                    })
                }else{
                    this.oldPrice = ''
                }
            },
            getAddOrder(e){     
                pay_orders({order_id: this.nextData.id ,pay_type:e,pay_money:this.nextData.pay_money * 1,authorize_code:this.authorize_code }).then(res=>{  
                    let a = JSON.stringify(res.data)
                    if(a == 'true'){
                        this.$Message.success('激活成功')
                        this.fkmodal = false
                        clearInterval(this.timer)
                        this.getList()
                    }else{
                        this.payFormData = res.data.data
                        if(this.nextData.pay_money*1==0){
                            return
                        }else{
                            this.pollingOrder()
                        }
                       
                    }
                    // this.pollingOrder()
                }).catch(err=>{
                    this.payFormData = {}
                    this.$Message.error(err.msg)
                })
            },
            getXTName(e){
                let a = ''
                this.applicationList.forEach(item => {
                    if(item.id == e){
                        a = item.name
                    }
                })
                return a  
            },
            pollingOrder(){
                this.timer = setInterval(() => {
                    this.$store.commit('changePollingSpin', false)
                    get_orderstatus({ order_no:this.payFormData.out_trade_no,uid:this.payFormData.uid}).then(res=>{
                        this.$store.commit('changePollingSpin', true)
                        if(res.data.is_pay == 1){
                            // this.payOK(res)
                            this.$Message.success('付款成功')
                            clearInterval(this.timer)
                            this.fkmodal = false
                        }
                    }).catch(res=>{
                        this.$store.commit('changePollingSpin', true)
                        this.$Message.error(res.msg)
                        clearInterval(this.timer)
                    })
                }, 2000)
            },
            goChooseType(e){                     
                if(this.pay_type != e){
                    // clearInterval(this.timer)
                    if(e=='3'){                        
                        this.authorize_code = ''
                        this.pay_type = e 
                        clearInterval(this.timer)
                    }else{
                        this.authorize_code = ''
                        this.pay_type = e 
                        clearInterval(this.timer)                        
                        this.getAddOrder(e)
                    }                    
                }else {

                }
            },
            closeModal(){
                this.fkmodal = false
                clearInterval(this.timer)
            },
            goSubmit(){                        
                if(!this.addOrderData.uid){
                    this.$Message.error('请选择账户')
                    return
                }
                if(!this.addOrderData.package_id){
                    this.$Message.error('请选择套餐')
                    return
                }
                if(this.addOrderData.pay_money == '' ){
                    this.$Message.error('请填写支付价格')
                    return
                }
                pay_orders(this.addOrderData).then(res=>{                    
                    this.showAddModal = false
                    this.getList()                    
                    if(this.addOrderData.pay_money==0){
                        this.$Message.success('支付订单成功')
                    }else {
                        this.payFormData = res.data.data
                        this.nextData.name = res.data.data.name
                        this.nextData.order_no = res.data.data.out_trade_no
                        this.nextData.package_name = res.data.data.package_name
                        this.nextData.pay_money = res.data.data.price
                        this.nextData.id = res.data.data.order_id
                        this.goPayData()                        
                    }                    
                }).catch(err=>{
                    this.$Message.error(err.msg)
                })
            },
            goEditMoney(){
                this.editMoneyModal = true    
                this.newMoney = this.nextData.pay_money
            },
            submitMoney(){
                if(this.newMoney == ''){
                    this.$Message.error('请输入要修改的价格')
                    return
                }
                this.$Modal.confirm({
                    title: '提示',
                    content: `确认修改该订单价格嘛`,
                    onOk: () => {
                        pay_orders({order_id: this.nextData.id ,pay_type: this.newMoney * 1 == 0 ? 0 : 1,pay_money:this.newMoney * 1 }).then(res=>{                            
                            if(this.newMoney * 1 ){
                                this.getList()
                                this.$Message.success('修改成功')
                                this.nextData.pay_money = this.newMoney
                                this.pay_type = 1
                                this.getAddOrder('1')             
                                this.editMoneyModal = false    
                            }else{
                                this.getList()
                                this.$Message.success('付款成功')
                                this.pay_type = 1
                                this.fkmodal = false
                                this.editMoneyModal = false    
                            }                                      
                        }).catch(err=>{
                            this.$Message.error(err.msg)
                        })
                    },
                    onCancel: () => {
                    }
                });
            },
            downPayment(){
                this.pay_type = ''
                clearInterval(this.timer)
                this.pay_type = 0
                this.payFormData.qrcode_url = ''
                this.authorize_code = ''
                this.$Modal.confirm({
                    title: '提示',
                    content: `是否确认该订单已经线下支付`,
                    onOk: () => {
                        let msg = this.$Message.loading({
                            content: '支付中，请稍后...',
                            duration: 0
                        })	
                        pay_orders({order_id: this.nextData.id ,pay_type: 0,pay_money:this.nextData.pay_money * 1 }).then(res=>{                          
                            if(res.data){
                                this.getList()
                                this.fkmodal = false
                                this.$Message.success('线下付款成功')
                            }     
                            setTimeout(() => {
                                msg()
                            }, 1000);                           
                        }).catch(err=>{
                            // this.payFormData = {}
                            this.pay_type = ''
                            this.$Message.error(err.msg)
                            setTimeout(() => {
                                msg()
                            }, 1000);     
                        })
                    },
                    onCancel: () => {
                        if(this.nextData.pay_money*1){
                            this.goChooseType('1')
                        }else{
                            this.pay_type = ''
                        }
                    }
                });
            },
            goPayData(){
                this.pay_type = 1
                this.authorize_code = '' 
                this.fkmodal = true               
            },          
            goGetgoodsList(){  
                if(this.addOrderData.goods_id ===  0 && this.addOrderData.type === '0'){
                    this.addOrderData.type = ''
                    this.addOrderData.package_id = ''
                    this.goodsList = []
                }        
                if((this.addOrderData.type === '0' || this.addOrderData.type === '1') && (this.addOrderData.goods_id||this.addOrderData.goods_id===0)){    
                                 
                    this.addOrderData.package_id = ''
                    this.goods_list()
                    return
                }else{
                    this.addOrderData.package_id = ''
                    return
                }
            },
            goods_list(){
                let newPageForm = {
                    page: 1,
                    limit: 9999,
                    type: this.addOrderData.type,            //0产品 1插件
                    application_id: this.addOrderData.goods_id
                }
                goods_list(newPageForm).then(res=>{
                    this.goodsList = []
                    this.goodsList = res.data.data
                    if(this.goodsList.length == 0){
                        this.$Message.error('暂无套餐~')
                    }
                })
            },
            application_list(){
                application_list().then(res=>{
                    this.applicationList = res.data
                })
            },
            getList(){ 
                this.loadingone = true  
                orders_list(this.pageForm).then(res=>{
                    this.loadingone = false
                    this.total = res.data.total
                    this.data6 = res.data.data
                })
            },
            goPay(){
                this.showOrderModal = false
                this.fkmodal = true
            },
            seeJHM(){
                this.reast()               
                this.addOrderData.order_id = ''
                this.addModalTitle = 'add'
                this.showAddModal = true               
            },
            reast(){
                this.addOrderData.goods_id = ''
                this.addOrderData.pay_type = 1
                this.addOrderData.pay_money = ''
                this.addOrderData.type = ''
                this.addOrderData.package_id = ''
                this.addOrderData.uid = ''
            },
            golistpay(e){
                this.fkmodal = true
                console.log('e',e)
                this.nextData = e
                if(e.pay_money*1 == 0){
                    this.pay_type = ''
                    // this.downPayment()
                }else{
                    this.pay_type = '1'
                    this.getAddOrder('1')
                }
            },
            goSearch(){
                this.pageForm.page = 1
                this.getList()
            },
            chooseData(e){
                console.log('e',e)
            },           
            search(){
                this.pageForm.name = this.$store.state.searchContent
                this.getList()
            },            
            addBtn(){
                if (this.seetitle=='查看') {
                    this.seemodal = false
                }else{
                    this.formData.uid = this.uid
                    edit_info(this.formData).then(res=>{
                        this.$Message.success(res.msg)
                        this.getList()
                        this.seemodal = false
                    }).catch(err=>{
                        this.$Message.error(err.msg)
                    })
                }
            },
            seexqModal(){
                this.$Message.error('功能暂未开启')
                return
                this.showRefundModal = true
                // this.showAddModal = true
                // this.addModalTitle = 'edit'
            },
            statusBtn(){
                if (this.contentTexe=='确认禁用此账户') {
                    edit_status({uid:this.uid,status:0}).then(res=>{
                        this.getList()
                        this.$Message.success(res.msg)
                        this.showAddModal = false
                    }).catch(err=>{
                        this.$Message.error(err.msg)
                    })
                }else{
                    edit_status({uid:this.uid,status:1}).then(res=>{
                        this.getList()
                        this.$Message.success(res.msg)
                        this.showAddModal = false
                    }).catch(err=>{
                        this.$Message.error(err.msg)
                    })
                }
            },
            delavatar(){
                this.formData.avatar = ''
                this.avatarView = ''
            },          
            del_use(e){
                this.$Modal.confirm({
                title: '提示',
                content: `是否确认删除该订单`,
                onOk: () => {
                    del_orders({uid:e.uid,order_id:e.id}).then(res=>{
                        this.$Message.success(res.msg)
                        this.getList()
                    }).catch(err=>{
                        this.$Message.error(err.msg)
                        this.getList()
                    })
                },
                onCancel: () => {
                }
                });
            },
            disable(e,uid){
                this.uid = uid
                if (e==1) {
                    this.contentTexe = '确认禁用此账户'
                }else{
                    this.contentTexe = '确认启用此账户'
                }
                this.showAddModal = true
            },           
            pageChange(e){
                this.pageForm.page = e
                this.getList()
            }
        }
    }
</script>

<style scoped>
.flex_btw{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.nochoose_box{
    width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border-top: 0.5px solid rgb(180, 180, 180);
    border-left: 0.5px solid rgb(180, 180, 180);    
    border-bottom: 0.5px solid rgb(180, 180, 180);
    cursor: pointer;
    /* border-radius: 4px; */
}
.choose_box{
    cursor: pointer;
    width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border-top: 0.5px solid rgb(180, 180, 180);
    border-left: 0.5px solid rgb(180, 180, 180);    
    border-bottom: 0.5px solid rgb(180, 180, 180);

    background: #FF761D;
    color: #fff;
}   
    .modal_contene{
        /* height: 500px; */
        overflow: auto;
    }
    .user_pic_box{
        margin: 10px 0;
        width: 70px;
        height: 70px;
    }
    .flex_sta {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .user_pic_box img{
        width: 100%;
        height: 100%;
        border-radius: 10px;
        object-fit: cover;
    }
    .Photo_wall{
        display: flex;
        align-items: center;
    }
   
    .photo_box img{
        width: 70px;
        height: 70px;
        object-fit: cover;
        border-radius: 10px;
        margin-right: 5px;
    }
    .btn{
        background: #FF761D;
        color: #0A1629;
    }
    .head_portrait{
        display: flex;
        flex-wrap: wrap;
    }
    .fk_class {
        width:300px;
    }
    .viewimg{
        position: relative;
        width: 80px;
        height: 80px;
        margin-right: 10px;
        margin-bottom: 10px;
        border-radius: 10px;
        overflow: hidden;
    }
    .viewimg img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .absolu_close:hover{
        opacity: 1;
    }
    .flex_cen {
        position: relative;
    }
    .san_class {
       display: flex;
       justify-content: flex-end;
       align-items: flex-end;
    }
    .absolu_close{
        cursor: pointer;
        position: absolute;
        top: 0;
        opacity: 0;
        left: 0;
        width: 80px;
        height: 80px;
        background: rgba(0,0,0,.5);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .upload_img{
        cursor: pointer;
        width: 80px;
        height: 80px;
        border: 1px solid #eee;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
    }
    .upload_img_txt{
        margin-top: -10px;
        font-size: 12px;
        color: #999;
    }
    .just_content{
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
<style>
    .ivu-table-header thead tr th {
        background: #fff !important;
    }
    .ivu-table-fixed-header thead tr th{
        background: #fff !important;
    }
    .ivu-table td, .ivu-table th {
        border-bottom: 1px solid #F0F6FC;
        color: #74798C;
    }
    .ivu-table:before{
        background: unset;
    }
    /* .ivu-modal-content{
        overflow: hidden;
    } */
    .ivu-modal-header{
        background: #fff;
    }
    .ivu-modal-close .ivu-icon-ios-close{
        color: #0A1629;
    }
    .ivu-modal-footer{
        border-top: unset;
    }
</style>